<template>
  <section class="relative">
    <div
      class="faq-bg bg-no-repeat bg-center md:bg-top bg-cover md:bg-contain absolute h-70v md:h-full md:top-0 md:bottom-0 left-0 right-0 md:right-2 -z-1"
    />
    <search-bar class="pt-24 md:pt-48 px-0 md:px-auto"/>
    <section class="container grid grid-rows-auto sm:grid-rows-1 grid-cols-12 sm:mt-16 mb-20 px-0 sm:px-6">
      <div class="row-start-1 col-start-1 col-end-3 md:col-start-2 flex md:justify-end pb-3 pl-3 sm:pl-0 md:pt-8 sm:pb-0">
        <nuxt-link :to="{name: 'faq'}" class="btn-round" aria-label="Terug">
          <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']"/>
        </nuxt-link>
      </div>
      <article class="row-start-2 sm:row-start-1 col-start-1 col-end-13 md:col-start-3 md:col-end-11 flex flex-col">
        <div class="item-heading w-11/12 sm:w-7/12 md:w-9/12 self-center h-24 card flex items-center justify-center z-10">
          <h3 class="text-heading text-white px-6">{{ faq.question }}</h3>
        </div>
        <div class="shadow-2xl sm:rounded-12p min-h-96 sm:mx-12 py-16 px-5 sm:p-16 -mt-8 bg-white z-0">
          <div class="font-semi answer-box" v-html="faq.answer"/>
        </div>
      </article>
    </section>
    <call-to-action
      title="Euhhh...?"
      content="Heb je een brandende vraag en stond hij hier niet tussen?"
      class="mt-16 mb-24"
    />
  </section>
</template>

<script>
import CallToAction from '~/components/CallToAction';
import SearchBar from '~/components/faq/SearchBar';

export default {
  components: {
    CallToAction,
    SearchBar,
  },
  async asyncData({$axios, error, params}) {
    try {
      const {data} = await $axios.get(`faqs/${params.slug}`);
      return {
        faq: data.data,
      };
    } catch (e) {
      error({statusCode: e.statusCode, message: e.message});
    }
  },
};
</script>

<style lang="sass" scoped>
.item-heading
  background-image: linear-gradient(to bottom, #023ddc 1%, #0a3592 98%)

.faq-bg
  background-image: url("~assets/img/bg-faq.svg")

.answer-box
  ::v-deep ul
    padding: 0

    li
      padding: 12px 0 0 24px !important
      &:last-of-type
        padding-bottom: 12px !important

      &::before
        top: 16px
        left: 0
        height: 16px
        width: 16px
</style>
